export default {
    about: {
        legacyLink: `/aboutus.aspx`,
        mfeLink: `/about`,
        shouldUseMFE: true,
        ariaLabel: 'Learn more about CarMax Auctions',
    },
    checkin: {
        legacyLink: ``,
        mfeLink: `/checkin`,
        shouldUseMFE: true,
        ariaLabel: 'Check in to CarMax Auctions',
    },
    checkout: {
        legacyLink: '',
        mfeLink: `/checkout`,
        shouldUseMFE: true,
        ariaLabel: 'Checkout cart',
    },
    contact: {
        legacyLink: `/contactus.aspx`,
        mfeLink: 'contact-us',
        shouldUseMFE: true,
        ariaLabel: 'Contact us',
    },
    error: {
        legacyLink: `/500.aspx`,
        mfeLink: `/500`,
        shouldUseMFE: true,
    },
    faq: {
        legacyLink: `/faq.aspx`,
        mfeLink: `/faq`,
        shouldUseMFE: true,
        ariaLabel: 'View our frequently asked questions',
    },
    home: {
        legacyLink: ``,
        mfeLink: `/`,
        shouldUseMFE: true,
        ariaLabel: 'Go to the CarMax Auctions homepage',
    },
    locations: {
        legacyLink: `/auctionlocation.aspx`,
        mfeLink: `/location`,
        shouldUseMFE: true,
        ariaLabel: 'View our auction locations',
    },
    locationState: {
        legacyLink: `/auctionlocation.aspx/statelocations/{{state}}`,
        mfeLink: `/location/{{state}}`,
        shouldUseMFE: true,
        ariaLabel: 'View our auction locations for this state',
    },
    myAuctions: {
        legacyLink: `/memberdashboard.aspx`,
        mfeLink: `/memberdashboard`,
        shouldUseMFE: true,
        ariaLabel: 'View information about upcoming auctions',
    },
    myList: {
        legacyLink: `/memberdashboard.aspx/savedvehicles`,
        mfeLink: `/mylist`,
        shouldUseMFE: true,
        ariaLabel: 'View your saved vehicles',
    },
    myProfile: {
        legacyLink: `/memberdashboard.aspx/myprofile`,
        mfeLink: `/myprofile`,
        shouldUseMFE: true,
        ariaLabel: 'View your profile',
    },
    myTransactions: {
        legacyLink: `/memberdashboard.aspx/mytransactions`,
        mfeLink: `/mytransactions`,
        shouldUseMFE: true,
        ariaLabel: 'View your transactions',
    },
    policy: {
        legacyLink: null,
        mfeLink: `/policy`,
        shouldUseMFE: true,
        ariaLabel: 'View our auction policy',
    },
    runlist: {
        legacyLink: `/runlist.aspx/display?count=all&page=1&view=photo&loc={{locationNum}}&column=runnumber&direction=ascending&origin=runlist&virtual_page=1#{{stockNum}}`,
        mfeLink: `/search?origin=runlist&loc={{locationNum}}`,
        shouldUseMFE: false,
        ariaLabel: 'Runlist',
    },
    search: {
        legacyLink: `${process.env.AUCTIONS_HOMEPAGE_URL}/memberdashboard.aspx/searchresults`,
        mfeLink: `/search`,
        shouldUseMFE: true,
        ariaLabel: 'Search for vehicles',
    },
    vdp: {
        legacyLink: `/vehicles.aspx/vehicledetail/{{stockNum}}`,
        mfeLink: `/vehicledetail/{{stockNum}}`,
        shouldUseMFE: true,
        ariaLabel: 'View vehicle details',
    },
    savedSearches: {
        legacyLink: `/memberdashboard.aspx/notifyme`,
        mfeLink: `/saved-searches`,
        shouldUseMFE: true,
        ariaLabel: 'View saved searches',
    },
};
